import { lazy } from 'react';
import type { AppRoute } from 'src/shared/routes';

const AccountPage = lazy(() => import('./AccountPage'));

// No nav entry: "Mi cuenta" is reached from the account menu, not worked in.
export const authRoutes: AppRoute[] = [
  { path: '/cuenta', name: 'Mi cuenta', element: AccountPage },
];
